import NamedDto from 'modules/base/dto/NamedDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class OutlierDetectorService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'outlierDetectorControl';
	}

	/**
		 * @return {Promise<NamedDto[]>}
		 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data != null ? response.data.map(d => new NamedDto().setup(d)) : []))
				.catch(reject);
		});
	}
}

export default new OutlierDetectorService();